import { trackGoogleAnalyticsEvent } from "@/lib/google-analytics";
import { captureFeatureUsed, postHogFeatures } from "@/lib/posthog-analytics";

type PaperTreeWhatsAppClick = {
  source: string;
  ctaLocation: string;
  tenantId?: number;
  nodeCount?: number;
  isDemo?: boolean;
};

export function trackPaperTreeWhatsAppClick({ source, ctaLocation }: PaperTreeWhatsAppClick): void {
  captureFeatureUsed(postHogFeatures.paperTree);

  trackGoogleAnalyticsEvent("paper_tree_whatsapp_lead", {
    source,
    cta_location: ctaLocation,
    method: "whatsapp",
    offer: "paper_tree",
  });
}
